<template>
	<div>
		<bread-crumbs
			:bread-crumbs="breadCrumbs"
			:current-title="$gettext('New email template type')"
			class="breadcrumbstyle"
		/>
		<v-row>
			<v-col
				cols="8"
			>
				<v-card class="ma-4">
					<v-card-title class="d-flex align-center">
						<translate>Create new email template type</translate>
					</v-card-title>
					<v-card-text>
						<v-form
							ref="form"
							v-model:model-value="emailTemplateTypeForm"
						>
							<v-row>
								<v-col>
									<v-text-field
										v-model:model-value="name"
										:label="$gettext('Name')"
										:rules="[v => !!v || $gettext('Name is required')]"
										required
										variant="outlined"
									/>
								</v-col>
								<v-col>
									<v-text-field
										v-model:model-value="title"
										:label="$gettext('Title')"
										:rules="[v => !!v || $gettext('Title is required')]"
										required
										variant="outlined"
									/>
								</v-col>
							</v-row>
							<v-row>
								<v-col>
									<v-select
										v-model:model-value="method"
										:items="methods"
										:item-title="$gettext(name)"
										:label="$gettext('Method')"
										:rules="[v => !!v || $gettext('Method is required')]"
										disabled
										variant="outlined"
									/>
								</v-col>
								<v-col>
									<v-select
										v-model:model-value="medium"
										:items="mediums"
										:label="$gettext('Medium')"
										:rules="[v => !!v || $gettext('Medium is required')]"
										variant="outlined"
									/>
								</v-col>
							</v-row>
							<v-row>
								<v-col>
									<v-select
										v-model:model-value="purpose"
										:items="translateArray(purposes)"
										item-title="translation"
										item-value="name"
										:label="$gettext('Purpose')"
										:rules="[v => !!v || $gettext('Purpose is required')]"
										variant="outlined"
									/>
								</v-col>
								<v-col>
									<v-select
										v-model:model-value="variable"
										:items="variables"
										:label="$gettext('Variable')"
										variant="outlined"
									/>
								</v-col>
							</v-row>
						</v-form>
					</v-card-text>
					<v-card-actions>
						<v-spacer />
						<v-btn
							color="primary"
							class="mr-4"
							@click="submitEmailtemplateType"
						>
							<translate>Save</translate>
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import axios from 'axios';
import {
	displayError,
	inform,
} from 'laravel-front-library';
import BreadCrumbs from '../../../molecules/BreadCrumbs.vue';

export default {
	name: 'EmailTemplateTypeCreate',
	components: {
		BreadCrumbs
	},

	data () {
		return {
			breadCrumbs: {
				'/bo/emailtemplates': 'Email Templates'
			},
			title: '',
			emailTemplateTypeForm: null,
			name: '',
			method: 'manual',
			methods: [],
			medium: 'email',
			mediums: [],
			purpose: null,
			purposes: [],
			variable: 'order',
			variables: [
				'user',
				'order',
				'claim',
			],
		};
	},

	created () {
		this.getEmailTemplateTypeCreateData();
	},

	methods: {
		/**
		 * Translate an array and returns an array with the original and translation
		 *
		 * @returns {Array} array with tranlsated objects
		 * @param {Array} selectArray array
		 */
		translateArray (selectArray) {
			if (selectArray) {
				return selectArray.map((item) => ({
					'translation': this.$gettext(item), 'name': item,
				}));
			}
			return [];
		},

		/**
		 * Get methods, mediums and purposes for emailtemplatetypes
		 *
		 * @returns {void} Sets data for methods mediums and purposes but doesn't return anything
		 */
		getEmailTemplateTypeCreateData () {
			axios.get('/bo/emailtemplates/emailtemplatetypecreatedata').then(({
				data
			}) => {
				this.methods = data.methods;
				this.mediums = data.mediums;
				this.purposes = data.purposes;
			});
		},

		/**
		 * Submit the email template type to be saved
		 *
		 * @returns {void} Redirects to the email template type in success otherwise an error gets displayed
		 */
		submitEmailtemplateType () {
			if (this.$refs.form.validate()) {
				const dataToSend = JSON.stringify({
					name: this.name,
					title: this.title,
					method: this.method,
					medium: this.medium,
					purpose: this.purpose,
					variables: this.variable,
				});
				const formData = new FormData();

				formData.set('formData', dataToSend);

				axios({
					url: '/bo/emailtemplates/createtemplatetype',
					method: 'POST',
					dataType: 'json',
					data: formData,
					config: {
						headers: {
							'Content-Type': 'multipart/form-data',
						},
					},
				}).then(({
					data
				}) => {
					inform(this.$gettext('Page submission successful'));
					window.location.href = `/bo/emailtemplates/view?id=${data}`;
				}).catch((error) => {
					displayError(this.$gettext(error.response.data));
				});
			}
		},
	},
};
</script>
